import UserMegaLeague from '@/models/MegaLeague/userMegaLeague';

export default class PaginatedUserMegaLeagueCollection {
  constructor({
    collection = [],
    count = null,
  } = {}) {
    this.userMegaLeagueCollection = UserMegaLeague.createCollectionFromObject(collection);
    this.count = count;
  }

  static createFromObject(data) {
    return new PaginatedUserMegaLeagueCollection(data);
  }
}
